'use client';

import { safeParseDate } from '@dte/otw-utils-dates/src/parse/date';
import type { ReactNode } from 'react';
import isNumeric from 'validator/es/lib/isNumeric';

export function isDateValue(value: ReactNode): boolean {
	if (!value) {
		return false;
	}

	if (value instanceof Date) {
		return true;
	}

	if (typeof value === 'string') {
		// Don't allow numeric strings to be parsed as dates
		if (isNumeric(value)) {
			return false;
		}

		// See if it can otherwise be parsed as a date
		const date = safeParseDate(value);
		return date !== undefined;
	}

	return false;
}
